import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconNotificationOffStyle0 = gravityIconIndividualCss;

const GravityIconNotificationOff = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '137224902e714f0aebd567302248cd71c04fc3fb', color: this.color, size: this.size }, h("svg", { key: 'da9c77ca4102696705d62daa9e6bc0f2f10fd29f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd76e248d6bbbdee4db62db5e04698878d0ba17a2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m3.41 2.35 16.24 16.24a.51.51 0 0 1-.04.71l-.35.35a.51.51 0 0 1-.71 0l-4.66-4.66H4.44a.49.49 0 0 1-.44-.72 10.73 10.73 0 0 0 1.11-4.7 8.19 8.19 0 0 1 .52-2.88L2.35 3.41a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0Zm5.137 14.93A.51.51 0 0 1 9 17h4a.51.51 0 0 1 .36.81 3 3 0 0 1-4.77 0 .51.51 0 0 1-.043-.53ZM6 13.49a12.29 12.29 0 0 0 .64-3.92 8 8 0 0 1 .21-1.69l5.61 5.61H6ZM8.51 3.48A5.38 5.38 0 0 1 11 3c3.66 0 5.93 3.12 5.92 6.63v2.27a.5.5 0 0 1-.5.5.52.52 0 0 1-.36-.16l-.43-.44a.66.66 0 0 1-.21-.53V9.63c0-2.55-1.52-5.13-4.42-5.13a4.84 4.84 0 0 0-1.77.31.51.51 0 0 1-.6-.14l-.34-.43a.54.54 0 0 1-.1-.3.5.5 0 0 1 .32-.46Z", fill: "currentColor" }))));
    }
};
GravityIconNotificationOff.style = GravityIconNotificationOffStyle0;

export { GravityIconNotificationOff as gravity_icon_notification_off };

//# sourceMappingURL=gravity-icon-notification-off.entry.js.map